import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { downloadCsv } from "@/lib/api";

export default function ExportButton({ path, filename, testid, label = "Export CSV" }) {
  const go = async () => {
    try {
      await downloadCsv(path, filename);
      toast.success(`${filename} downloaded`);
    } catch (e) {
      toast.error("Export failed");
    }
  };
  return (
    <Button variant="outline" data-testid={testid} onClick={go} className="min-h-[44px]">
      <Download className="w-4 h-4 mr-1.5" /> {label}
    </Button>
  );
}
